'use strict';
const React = require('react');
//const SearchComponent = require('../features/pricing_type/' + process.env.PRICING_TYPE + '/header/search');
const CustomHeader = require('../custom/header/custom-header');


class HeaderLayoutBottomComponent extends React.Component {
    constructor(props) {
        super(props);

        this.renderCategories = this.renderCategories.bind(this);
    }

    renderCategories() {
        if (this.props.categories != null && Array.isArray(this.props.categories)) {
            var categoryViews = this.props.categories.map(function (item, index) {
                return (
                    <option value={item.ID} key={item.ID}>{item.Name}</option>
                );
            });
            return categoryViews;
        } else {
            return '';
        }
    }

    renderHomepageUrl() {
        if (this.props.homepageUrl) {
            if (this.props.homepageUrl.startsWith('http')) {
                return this.props.homepageUrl;
            }
            return process.env.PROTOCOL + '://' + this.props.homepageUrl;
        }
        return '/';
    }

    render() {
        var headerSearchInHome = 'headerSearch-NotinHome';
        if (window && window.location && window.location.pathname == "/") {
            headerSearchInHome = 'headerSearch-inHome';
        }
        return (
            <div className="header-bottom" id="custom-header-bottom">
                <div className="container">
                    <ul className="header-menus">
                        <li className="h-logo" id="logo-megamak">
                            <a href={process.env.ENVIROMENT_URL/*this.renderHomepageUrl()*/}>
                                {/*<img src={this.props.logoUrl} />*/}
                                {<img src="/assets/images/bepensa/logo-Megamak.png"></img>}
                                
                            </a>
                        </li>
                        <li className={"h-search "  + headerSearchInHome} id="h-search-header">
                            <CustomHeader {...this.props}></CustomHeader>
                        </li>
                    </ul>
                </div>  
            </div>
        );
    }
}

module.exports = HeaderLayoutBottomComponent;
/*
<SearchComponent
    keyword={this.props.keyword}
    renderCategories={this.renderCategories}
    searchGooglePlaces={this.props.searchGooglePlaces} />
*/